/* eslint-disable import/prefer-default-export */

export const COUNT_OPERATIONS = {
  LESS: 'less',
  LESS_OR_EQUAL: 'lessOrEqual',
  EQUAL: 'equal',
  GREATER_OR_EQUAL: 'greaterOrEqual',
  GREATER: 'greater'
};
